<template>
  <div id="welcome">
    <!-- <el-tabs> -->
    <!-- <el-tab-pane label="我的待办"> -->
    <ul class="content-title">
      <li @click="tabClick(item, index)" :class="{ active: index == num }" v-for="(item, index) in tabList"
        :key="index">
        <div v-if="item.number">
          <el-badge :type="item.type" :value="item.number">
            {{ item.name }}
          </el-badge>
        </div>
        <div v-else>
          {{ item.name }}
        </div>
      </li>
    </ul>
    <div class="my-process">
      <el-row>
        <!-- 左边部分 -->
        <el-col>
          <!-- 用户信息表格 -->
          <el-collapse v-model="priorityNames" class="top">
            <ChangeItem ref="items" :tableInfo="tableInfo" @rowDataShow="rowClick">
              <span class="title" slot="title">{{ $t("message.title.priorityChange") }}</span>
              <template v-if="!num" v-slot="{ row }">

                <div>
                  <el-button size="mini" type="success" icon="el-icon-check" circle @click="approveChange"></el-button>
                  <el-button size="mini" type="danger" icon="el-icon-close" circle @click="rejectChange"></el-button>
                </div>
                <!-- <div v-else>
                  <el-button size="mini">{{ $t("message.button.details") }}</el-button>
                </div> -->
              </template>
            </ChangeItem>

            <!-- 封面 -->
            <Cover :cover="coverData"></Cover>
            <AffectedItem :tableHead="affectItemColumn" :affectData="affectItemData"></AffectedItem>
            <Workflow :statusInfoShow="statusInfo" :process_Num="processNum" :tableHead="workflowColumn"
              :workflowTable="workflowData"></Workflow>
          </el-collapse>
        </el-col>
      </el-row>
    </div>
    <el-dialog v-if="approveWindow" v-loading="btnLoading" :title="$t('message.title.approve')"
      :visible.sync="approveWindow">
      <model @subData="approve" ref="approveModel">
        <el-button @click="approveWindow = false">{{ $t("message.button.cancel") }}</el-button>
      </model>
    </el-dialog>
    <el-dialog v-if="rejectWindow" v-loading="btnLoading" :title="$t('message.title.reject')"
      :visible.sync="rejectWindow">
      <model @subData="reject" ref="rejectModel">
        <el-button @click="rejectWindow = false">{{ $t("message.button.cancel") }}</el-button>
      </model>
    </el-dialog>


  </div>
</template>
<script>
//import echarts from "echarts";
// import aplayer from "vue-aplayer";
import Cover from "./component/cover";
import ChangeItem from "./component/changeItem";
import AffectedItem from "./component/AffectedItem";
import Workflow from "./component/workflow.vue";
import model from "./component/model.vue";
import { mapState, mapMutations } from 'vuex';
import axios from "axios";
import {
  loadMyWorkFlowsAPI, approveChangeAPI, rejectChangeAPI,
  loadWorkflowAPI, loadTableAPI, getStatusAPI
} from "./ProgressAPI";
import FormatData from './ProMethods';

export default {
  name: "Welcome",
  components: {
    Cover,
    AffectedItem,
    ChangeItem,
    Workflow,
    model,
  },

  data() {
    return {
      approveWindow: false,
      rejectWindow: false,
      statusId: "",
      btnLoading: false,

      //我的待办工作流
      priorityNames: ["1"],

      affectPriorityData: [],
      statusInfo: [],
      workflowColumn: [],
      workflowData: [],
      processNum: 0,
      affectItemColumn: [],
      affectItemData: [],
      clickItemId: "",

      workflowId: "",
      workflowStatusId: "",


      tabType: {},
      listIndex: "",

      //我的待办封面
      coverData: [],

      value: new Date(),
      userInfo: {},

      //我的待办待处理变更
      tableInfo: [],

      num: 0,
      tabList: [
        {
          name: this.$t("message.title.myPriority"),
        },
        {
          name: this.$t("message.title.mySubmit"),
        },
        {
          name: this.$t("message.title.myTracing"),
        },
        {
          name: this.$t("message.title.myNotice"),
        },
      ],
      currenRow: {}
    };
  },
  mounted() { },
  methods: {
    ...mapMutations(['setProcessLength']),
    tabClick(res, index) {
      this.coverData = [];
      this.workflowColumn = [];
      this.workflowData = [];
      this.affectItemColumn = [];
      this.affectItemData = [];
      this.statusInfo = [];
      this.processNum = 0;
      this.clickItemId = "";
      this.num = index;
      this.tableInfo = this.allData[index]
    },
    approve(e) {
      console.log(this.currenRow);
      this.btnLoading = true;
      let changeBaseId = this.currenRow.classId.toString().substring(0, 3);
      if (changeBaseId == 301) {
        this.approveProject(e);
      } else {
        e.status = this.statusId;
        e.objectId = { ...this.currenRow }
        // return;
        // axios.post("/pmdm/changes/approveChange", e)
        approveChangeAPI(e).then((res) => {
          if (res.data.code == 200) {
            this.setProcessLength(res.data.object.size)
            this.approveWindow = false;
            this.$message({
              message: res.data.message,
              type: "success",
            });
          }
          this.tableInitialization();
        }).finally(() => {
          this.btnLoading = false
        })
      }
    },
    approveProject(e) {
      var approveChangeRequest = {
        objectId: {
          id: this.currenRow.id,
          classId: this.currenRow.classId,
          subClassId: this.currenRow.subClassId
        },
        approvers: e.approvers,
        comments: e.comments,
        status: this.currenRow.statusId,
        intermediateId: this.currenRow.rowId,
      };
      axios.post("/ppm/project/imdApproveWorkflow", approveChangeRequest).then((res) => {
        if (res.data.code == 200) {
          this.approveWindow = false;
          this.$message({ message: res.data.message, type: "success", });
        }
        this.tableInitialization();
      });
    },
    reject(e) {
      this.btnLoading = true;
      let changeBaseId = this.currenRow.classId.toString().substring(0, 3);
      if (changeBaseId == 301) {
        this.rejectProject(e);
      } else {
        e.status = this.statusId;
        e.objectId = { ...this.currenRow };
        var m = { approvers: "rejecters" };
        var f = Object.keys(e).reduce((n, key) => {
          let k = m[key] || key;
          n[k] = e[key];
          return n;
        }, {});
        if (e.comments == "") {
          this.$message({ message: this.$t("message.error.rejectNoComments"), type: "error", });
          this.btnLoading = false;
          return false;
        }

        // axios.post("/pmdm/changes/rejectChange", f)
        rejectChangeAPI(f).then((res) => {
          if (res.data.code == 200) {
            this.rejectWindow = false;
            this.$message({
              message: res.data.message,
              type: "success",
            });
          }
          // this.loginReport(this.userInfo.username);
          this.tableInitialization();
        }).finally(() => {
          this.btnLoading = false;
        });
      }
    },
    rejectProject(e) {
      var rejectChangeRequest = {
        objectId: {
          id: this.currenRow.id,
          classId: this.currenRow.classId,
          subClassId: this.currenRow.subClassId
        },
        rejecters: e.approvers,
        comments: e.comments,
        status: this.currenRow.statusId,
        intermediateId: this.currenRow.rowId,
      };
      if (rejectChangeRequest.comments == "") {
        this.$message({ message: this.$t("message.error.rejectNoComments"), type: "error", });
        return false;
      }
      axios.post("/ppm/project/imdRejectWorkflow", rejectChangeRequest).then((res) => {
        if (res.data.code == 200) {
          this.rejectWindow = false;
          this.$message({
            message: res.data.message,
            type: "success",
          });
        }
        this.tableInitialization();
      });
    },
    // 待处理变更中的流程批准或拒绝后，调用该方法使页签刷新并关闭除第一个外所有折叠面板
    tableInitialization() {
      this.coverData = [];
      this.workflowColumn = [];
      this.workflowData = [];
      this.affectItemColumn = [];
      this.affectItemData = [];
      this.statusInfo = [];
      this.priorityNames = ["1"];
      this.loginReport(this.num);
    },
    approveChange(row) {
      // console.log("message");
      // this.currenRow = row

      this.$confirm('请确认是否已查看完整变更内容', this.$t('message.tips.tip'), {
        confirmButtonText: this.$t('message.button.affirm'),
        cancelButtonText: this.$t('message.button.cancel'),
        type: 'warning'
      }).then(() => {
        this.approveWindow = true;
        // this.currenRow = {...row}
      }).catch(() => {
        // this.currenRow = {}
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
      // this.approveChange = true

    },
    rejectChange() {
      // console.log(e);
      // this.approveChange = true
      this.$confirm('请确认是否已查看完整变更内容', this.$t('message.tips.tip'), {
        confirmButtonText: this.$t('message.button.affirm'),
        cancelButtonText: this.$t('message.button.cancel'),
        type: 'warning'
      }).then(() => {
        this.rejectWindow = true;
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
      // this.rejectWindow = true;
    },
    getWorkflowData(e) {

      const n = e.classId.toString().substring(0, 3) == 401 ? 41 : 5
      const list = [
        loadTableAPI({ ...e, tableId: 1 }),
        loadTableAPI({ ...e, tableId: n }),
        loadWorkflowAPI(e)
      ];
      return Promise.all(list)

    },
    sdfsdf(e) {
      const obj = {
        changeId: 0,
        changeClassId: 0,
        changeSubClassId: 0,
        ...e.seriesId
      };
      this.getWorkflowData(obj).then(res => {
        const [a, b, c] = res;
        this.coverData = FormatData.getCover(a.data.object.table);
        const [d, f] = [b, c].map(i => FormatData.getLoadTableData(i.data.object.table))
        this.affectItemColumn = d.column
        this.affectItemData = d.data
        this.workflowColumn = f.column
        this.workflowData = f.data
        const { id, classId } = e.seriesId;
        const list = classId.toString().substring(0, 3) == 401 ? [4010004, 4010005] : [1004008, 1004002]
        const [workflowId, statusId] = FormatData.getStatusVal(list, a.data.object.table)
        const obj = { id, classId, statusId, workflowId }
        return getStatusAPI(obj)
      }).then(res => {
        this.statusInfo = res.data.object;
        this.processNum = this.statusInfo.map(i => i.id).indexOf(Number(e.statusId));
        this.priorityNames = ["1", "2", "3", "4"];
      })
    },
    rowClick(e) {
      console.log(e);
      if (this.clickItemId == e.seriesId.id) {
        return;
      }
      let changeBaseId = e.seriesId.classId.toString().substring(0, 3);
      if (changeBaseId == 301) {
        this.showProjectWorkflowInfo(e);
      } else {
        this.currenRow = { ...e.seriesId }
        this.statusId = e.statusId;
        this.sdfsdf(e);
      }
      this.clickItemId = e.seriesId.id

    },
    async showProjectWorkflowInfo(e) {
      this.workflowColumn = [];
      this.currenRow = { ...e.seriesId };
      this.currenRow.intermediateId = e.rowId;
      this.currenRow.statusId = e.statusId;
      this.currenRow.rowId = e.rowId;
      let obj = { ...e.seriesId };
      obj.tableId = 1;
      axios.get(`/ppm/project/loadTable${this.params(obj)}`).then(res => {
        let arr = res.data.object.table.columnInfo;
        let arrContent = res.data.object.table.rows[0].cells;
        this.coverData = arr.names.map((i, e) => {
          return { name: i, val: arrContent[e].val, type: arr.attTypes[e] }
        })
      });
      var workflowObj = {
        id: e.seriesId.id,
        classId: e.seriesId.classId,
        subClassId: e.seriesId.subClassId,
        intermediateId: e.rowId,
        tableId: 57
      }
      axios.get(`/ppm/project/queryIntermediateWorkflow${this.params(workflowObj)}`).then((res) => {
        this.statusInfo = res.data.object.allStatus;
        let arr = this.statusInfo.map((i) => {
          return i.id;
        });
        this.processNum = arr.indexOf(Number(e.statusId));
        let tableNames = res.data.object.workflowTable.columnInfo.names;
        for (let i = 0; i < tableNames.length; i++) {
          const e = tableNames[i];
          this.workflowColumn.push({ id: "pro" + i, name: e });
        }
        this.workflowColumn.shift();
        var workflowTableObj = {
          code: 200,
          message: "Success",
          object: {
            table: res.data.object.workflowTable
          }
        };
        let a = this.getNewTableContentData(workflowTableObj);
        let b = Object.keys(a[0]);
        b = b.map((i) => {
          return "pro" + i;
        });
        this.workflowData = [];
        for (let i = 0; i < a.length; i++) {
          const e = a[i];
          let f = {};
          for (let j = 0; j < b.length; j++) {
            const el = b[j];
            f[el] = e[j];
          }
          this.workflowData.push(f);
        }
      });
      this.affectItemColumn = [];
      this.priorityNames = ["1", "2", "4"];
    },


    loginReport() {
      const list = new Array(4).fill('_').map((i, e) => {
        return loadMyWorkFlowsAPI(e + 1)
      })
      const getNum = (e, table) => {
        if (e === 0) {
          return table.totalRecords;
        }
        if (e === 1) {
          return table.rejectTotal;
        }
        return 0
      }
      Promise.all(list).then(res => {
        console.log(res);
        this.allData = res.map((i, e) => {
          const table = i.data.object.table;
          this.tabList[e].number = getNum(e, table);
          this.tabList[e].type = !e ? 'danger' : 'warning';
          return FormatData.getTableData(table)
        });
        console.log(this.allData);
        this.tableInfo = this.allData[0];
        this.setProcessLength(this.tableInfo.length)
      })
    },
  },
  created() { },
  mounted() {
    this.loginReport()
  },
};
</script>

<style>
.top .el-collapse-item__arrow {
  font-size: 20px;
  color: #3ea0fb;
  font-weight: 600;
}

.my-process .has-gutter {
  font-size: 16px;
  color: #000;
}
</style>
<style scoped>
.title {
  border-left: 8px solid #3ea0fb;
  padding-left: 12px;
  font-size: 18px;
  height: 18px;
  line-height: 18px;
}

#welcome .el-tabs__header {
  padding-left: 16px !important;
  margin-bottom: 0 !important;
  font-size: 18px !important;
  height: 40px !important;
}

#welcome .el-tabs__item {
  background: #fff;
  border: none;
}

#welcome .el-tabs__item.is-active {
  color: #409eff;
  background: #fff;
}

#welcome .el-tabs__nav-wrap::after {
  background-color: #fff !important;
}

#welcome .el-tabs__item {
  font-size: 18px;
}

#welcome .el-table thead {
  color: #000 !important;
}

.box-card {
  margin-top: 5px;
}

.content-title {
  padding: 0;
  padding-left: 15px;
  margin: 0;
  overflow: hidden;
  background-size: 100% 100%;
  height: 58px;
  background-color: #fff;
}

.content-title li {
  float: left;
  padding: 16px 12px 11px 12px;
  font-size: 18px;
  cursor: pointer;
  margin-right: 18px;
}

.content-title li:hover {
  border-bottom: 3px solid #4b92ff;
  color: #4b92ff;
}

.content-title .active {
  border-bottom: 3px solid #4b92ff;
  color: #4b92ff;
}

.slide-fade-enter-active {
  transition: all 0.1s ease;
}

.slide-fade-leave-active {
  transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active for below version 2.1.8 */
  {
  transform: translateY(-10px);
  opacity: 0;
}
</style>
